import { render, staticRenderFns } from "./ContentRight.vue?vue&type=template&id=f253c080&scoped=true"
import script from "./ContentRight.vue?vue&type=script&lang=js"
export * from "./ContentRight.vue?vue&type=script&lang=js"
import style0 from "./ContentRight.vue?vue&type=style&index=0&id=f253c080&prod&lang=css"
import style1 from "./ContentRight.vue?vue&type=style&index=1&id=f253c080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f253c080",
  null
  
)

export default component.exports